import { Button } from 'mmds';
import Skeleton from 'mmds/src/components/skeleton/Skeleton';
import s from './product-truefit.module.css';
import { Icon } from 'mmds';
import cn from 'clsx';

const ProductTruefitCTA = ({ loading, ctaMessage, fitMessage, onClick }) => {
    const transformFitMessage = (fitMessage) => {
        if (fitMessage === 'Runs true to size') {
            return 'True to size';
        }
        return fitMessage;
    };

    const transformCTAMessage = (ctaMessage) => {
        if (ctaMessage === 'Which Size Fits Me?') {
            return 'Which size fits me?';
        }
        return ctaMessage;
    };

    if (loading)
        return (
            <Skeleton
                backgroundColor={'transparent'}
                className={s.truefitCTASkeleton}
            >
                <Skeleton
                    height={'24px'}
                    width={'100%'}
                    backgroundColor={'var(--color-brand-steel)'}
                />
            </Skeleton>
        );

    const transformedFitMessage = transformFitMessage(fitMessage);
    const transformedCtaMessage = transformCTAMessage(ctaMessage);

    return (
        <div className={cn(s.root)}>
            <Icon icon="truefit" />
            {fitMessage && (
                <span className="mmds-component-one-detail">
                    Fit: {transformedFitMessage}
                </span>
            )}
            <Button
                className={s.truefitCTA}
                variant="text"
                padding="zeroInline"
                onClick={onClick}
            >
                {transformedCtaMessage || 'What’s my size'}
            </Button>
        </div>
    );
};

export default ProductTruefitCTA;
